import { z } from 'zod';

/**
 * 見込み客（Lead）登録用 Zod スキーマ
 * Domain Keeper: 「見込み客」の正式英語名は Lead (Prospect / Contact は禁止)
 */
export const LeadSchema = z.object({
  companyName: z.string().min(1, '会社名を入力してください').max(100, '会社名は100文字以内で入力してください'),
  contactName: z.string().min(1, '氏名を入力してください').max(50, '氏名は50文字以内で入力してください'),
  workEmail: z.string().email('有効な企業メールアドレスを入力してください').max(100),
  phoneNumber: z.string().regex(/^[0-9\-+()]{9,20}$/, '有効な電話番号を入力してください').optional().or(z.literal('')),
  workspaceMembersCount: z.enum(['1-50', '51-200', '201-1000', '1001+'], {
    errorMap: () => ({ message: 'Google Workspace アカウント（Member）数を選択してください' }),
  }),
  inquiryType: z.enum(['poc', 'demo', 'document', 'other'], {
    errorMap: () => ({ message: 'お問い合わせ種別を選択してください' }),
  }),
  message: z.string().max(1000, 'お問い合わせ内容は1000文字以内で入力してください').optional(),
  source: z.string().default('landing_page'),
});

export type LeadInput = z.infer<typeof LeadSchema>;

export interface LeadSubmissionResult {
  success: boolean;
  leadId?: string;
  message?: string;
}
